import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from  'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { NavLink } from 'react-router-dom';

import Logo from './Logo';
import ProfileMenu from './ProfileMenu';
import { commonStyles, COLORS } from '../styles/styles';

import { MDBBreadcrumb, MDBBreadcrumbItem, MDBContainer } from "mdbreact";
import {selectedProgram, selectedModule, getSelectedProject} from '../redux/selectors'

import authHOC from '../Components/AuthHOC';

import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';

import { selectMessage,resetSelectionMessage } from '../redux/reducers/teamMembersFull';

import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import logoWide from '../assets/cs_logo.png';
import AvatarCirce from './AvatarCircle';
import SearchIcon from '@material-ui/icons/Search';

import { selectUserContent, getUserProgramsFullRequest,selectAssessment, submitMCQ,selectAttempt, toggleAssignmentView, selectUserModule,
  selectUserPrograms, selectUserVersion } from '../redux/reducers/userProgramsFull';



const BreadCrumbArea = ({ classes, ...props }) => {
  const { loginReducer, location } = props;
  var paths = location.pathname.slice(1).split('/')
  
  var pathArray = [{name:'Home', active:false, title:'PROJECTS'}];
  console.log('paths', paths)
  for (let i = 0; i < paths.length; i++) {
    const element = paths[i];
    if(i==0){
      // if(element=='rollouts' && selectedProject){
      //   pathArray.push({name:props.selectedProject.name, active:true , title:'ROLLOUTS'})
      // }
//       if(element=='users' && getProgram){
//         pathArray.push({name:getProgram.name, active:true , title:'USERS'})
//       }
//       if(element=='content' && getProgram){
//         pathArray.push({name:getProgram.name, active:false, title:'CONTENT'})
// //pathArray.push({name:getModule.name, active:true})
//       }
//       if(element=='versions' && getProgram){
//         pathArray.push({name:getProgram.name, active:false, title:'INSTANCES'})
// //pathArray.push({name:getModule.name, active:true})
//       }
//       if(element=='assessments' && getProgram){
//         pathArray.splice(0,1);
//         pathArray.push({name:'Assessments', active:false , title:'ASSESSMENTS'})
//         pathArray.push({name:getProgram.name, active:true , title:'ASSESSMENTS'})
//       }else if(element=='assessments'){
//         pathArray.slice(0,1);
//         pathArray.push({name:'Assessments', active:true , title:'ASSESSMENTS'})
//       }

//       if(element=='tools' && getProgram){
//         pathArray.splice(0,1);
//         pathArray.push({name:'Tools', active:false , title:'TOOLS'})
//         pathArray.push({name:getProgram.name, active:true , title:'TOOLS'})
//       }else if(element=='tools'){
//         pathArray.slice(0,1);
//         pathArray.push({name:'Tools', active:true , title:'TOOLS'})
//       }

//       if(element=='chooseassessment'){
//         pathArray.splice(0,1);
//         pathArray.push({name:'Assessments', active:false , title:'ASSESSMENTS'})
//       }
//       if(element=='choosetool'){
//         pathArray.splice(0,1);
//         pathArray.push({name:'Tools', active:false , title:'TOOLS'})
//       }
    }
    if(i==2){
     // pathArray.push({name:getModule.name, active:true})
    }
   
}

  return (
    <div style={{position:'relative', marginTop:64, paddingTop:20}}>
      {location.pathname.slice(1).split('/').length < 5 && (
          <div style={{maxWidth:1200, margin: '0 auto'}}>
            <div className="pl-2">
              {/* <h5 className={classes.slimColumnHeader}>
                {pathArray[pathArray.length-1].title}
              </h5> */}
              <div>
                <MDBBreadcrumb>
                {pathArray.map(item => {
                  if(item.active==true){
                    return <MDBBreadcrumbItem active key={Math.random()}>{item.name}</MDBBreadcrumbItem>
                  }
                  return <MDBBreadcrumbItem  key={Math.random()}>{item.name}</MDBBreadcrumbItem>
          
                })
                }
                </MDBBreadcrumb>
                </div>
              </div>
            
            <div>
              {/* <Form.Group>
                            <InputGroup>
                                
                                <Form.Control
                                    type="text"
                                    placeholder="Search here.."
                                />
                                <InputGroup.Prepend>
                                    <InputGroup.Text>
                                        <SearchIcon/>
                                    </InputGroup.Text>
                                </InputGroup.Prepend>
                            </InputGroup>
              </Form.Group> */}
            </div>
          </div>
      )}
    </div>
  );
};

const styles = theme => ({
  ...commonStyles,
  mainHeaderTitle: {
    marginRight: 30,
    marginLeft: 400,
    color: '#fff',
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.fontSize,
    letterSpacing: 0.5,
    textAlign: 'right',
    display: 'inline-block',
    paddingTop:10
  },
  mainHeader: {
    backgroundColor: '#8a272a',
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    height: 47,
  },
  toolbar: {
    minHeight: 35,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 455,
  },
  mainHeaderNav: {
    width: '100%',
  },
  mainHeaderNavLink: {
    textTransform: 'uppercase',
    padding: '10px 0',
    textDecoration: 'none',
    color: '#fff',
    fontWeight: 240,
  },
  mainHeaderNavLinkActive: {
    fontWeight: 400,
  }
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  selectedProject: getSelectedProject(state),
  userProgramsFull: state.userProgramsFullReducer,
});

const mapDispatchToProps = dispatch => ({
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  selectUser: contentId => dispatch(selectUser(contentId)),
  selectUserPrograms: moduleId => dispatch(selectUserPrograms(moduleId)),
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  authHOC,
  withStyles(styles),
)(BreadCrumbArea);

BreadCrumbArea.propTypes = {
  classes: PropTypes.instanceOf(Object),
  loginReducer: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Components/BreadCrumbArea.jsx